import Transform from './Base';

export default class ProgressTransform extends Transform {
  /**
   * Method used to transform fetched job progress statuses.
   *
   * @param jobs The fetched jobs.
   *
   * @returns {Object} The transformed job.
   */

  static fetchCollection(jobs) {
    return jobs.reduce((res, cur) => {
      res[cur.job_id] = {
        progress: cur.progress,
      };
      return res;
    }, {});
  }
}
